import { createAction, props } from '@ngrx/store'
import { HttpErrorResponse } from '@angular/common/http'
import { StripeError } from '@stripe/stripe-js'

export const initStripeElements = createAction(
  '[Stripe/API]  Init Stripe Elements',
  props<{ isSetupIntent?: boolean }>(),
)

export const prepareForNewCardSetup = createAction(
  '[Stripe Page] Prepare for new card setup',
  props<{ profileUuid: string }>(),
)

export const prepareForNewCardSetupSuccess = createAction('[Stripe/API] Prepare for new card setup Success')

export const prepareForNewCardSetupFailure = createAction(
  '[Stripe/API] Prepare for new card setup Failure',
  props<{ error: HttpErrorResponse | string }>(),
)

export const payWithAnotherCard = createAction(
  '[Stripe Page] pay with another card',
  props<{ profileUuid: string; clientSecret: string }>(),
)

export const payWithAnotherCardSuccess = createAction('[Stripe Page] pay with another card Success')

export const addNewCard = createAction(
  '[Stripe Page] Add a new card',
  props<{ user: string; stripeCustomer: string; onSuccess?: () => void }>(),
)

export const addNewCardSuccess = createAction('[Stripe/API] Add a new card Success')

export const addNewCardFailure = createAction(
  '[Stripe/API] Add a new card Failure',
  props<{ error?: HttpErrorResponse | StripeError }>(),
)

export const handlePaymentCompletion = createAction('[Stripe/API] Handle Payment Completion')

export const onPaymentSuccess = createAction('[Stripe/API] On Payment Success')

export const cancelPayment = createAction('[Stripe/API] Cancel Payment')

export const cancelPaymentSuccess = createAction('[Stripe/API] Cancel Payment Success')

export const cancelPaymentFailure = createAction(
  '[Stripe/API] Cancel Payment Failure',
  props<{ error: HttpErrorResponse }>(),
)
